import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-dispatch-save-filter-dialog',
  templateUrl: './dispatch-save-filter-dialog.component.html',
  styleUrls: [ './dispatch-save-filter-dialog.component.scss' ]
})
export class DispatchSaveFilterDialogComponent implements OnInit {
  filterNameCtrl = this.fb.control('', [ Validators.required ]);

  constructor(readonly fb: FormBuilder, readonly dialogRef: MatDialogRef<DispatchSaveFilterDialogComponent>) {}

  ngOnInit(): void {}

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (this.filterNameCtrl.valid) {
      this.dialogRef.close(this.filterNameCtrl.value);
    }
  }
}
